var path = 'admin/templates/api-key.html';
var html = "<div template-include include-name=\"admin.clinic.api-key.modal\"></div>\n\n<h2>{{clinic.name}} - API Key</h2>\n\n<div ng-if=\"api_key\">\n  {{timestamp | date: \"d MMM y h:mm:ss a\"}}<br>\n  <label><strong>New key:</strong> <input class=\"api-key\" ng-model=\"api_key\" readonly/></label>\n    <button ng-click=\"clinicCtrl.copyApiKeyToClipboard()\">Copy</button>\n</div>\n\n<button type=\"button\" class=\"btn btn-block btn-success\" ng-click=\"clinicCtrl.openApiKeyModal()\">Generate new API Key</button>\n\n<ui-view></ui-view>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/api-key.html
 ** module id = 286
 ** module chunks = 0
 **/